<div class="header">
	<h3>
		{{ 'SUBTITLES' | translate }}
	</h3>
	<bb-info [contents]="'HELP.UPLOAD_SUBTITLES' | translate" [icon]="'help'"></bb-info>
</div>

<div class="header-buttons">
	<div class="header">
		<bb-upload (bbFileCreated)="subtitleFileCreated($event)" [multi]="false" [onFilter]="filterSubtitleUploads" [hideDropText]="true" [uploadText]="'UPLOAD_SUBTITLES' | translate"></bb-upload>
	</div>

	<div class="header">
		<bb-button icon="plus" (click)="addSubtitle()" data-cy="mediaclip-add-subtitle">{{ 'CREATE_SUBTITLE' | translate }}</bb-button>
	</div>
</div>

<bb-table-container>
	<bb-table-header>
		<bb-table-header-cell property="language">{{ 'LANGUAGE' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="status" class="icon">&nbsp;</bb-table-header-cell>
		<bb-table-header-cell class="buttons"></bb-table-header-cell>
	</bb-table-header>

	<bb-table-row *ngIf="subtitleRows?.length === 0">
		<bb-table-cell property="language" class="overflow"><span>{{ 'NO_SUBTITLES_YET' | translate }}</span></bb-table-cell>
		<bb-table-cell property="status">&nbsp;</bb-table-cell>
		<bb-table-cell property="status">&nbsp;</bb-table-cell>
	</bb-table-row>

	<bb-table-row *ngFor="let row of subtitleRows; let i = index; trackBy: trackBy" [row]="row">
		<bb-table-cell property="language" class="overflow"><span>{{ row?.data?.automatedName || row?.data?.languagename }}</span></bb-table-cell>
		<bb-table-cell property="status" [ngClass]="{'status': row?.data?.status}"><span [innerHTML]="row?.data | statusIcon"></span></bb-table-cell>
		<bb-table-cell class="buttons">
			<a class="button" (click)="deleteSubtitle(row.data.id, row.data.languagename)">
				<i class="fa fa-trash"></i>
			</a>
			<a class="button" [class.disabled]="row?.id === 'new' || row?.data?.status !== 'published'"
				(click)="showPreview(row?.data?.id)">
				<i class="fa fa-eye"></i>
			</a>
			<a class="button" (click)="downloadSubtitle(row?.data?.id, $event)">
				<i class="fa fa-download"></i>
			</a>
			<a class="button" (click)="editSubtitle(row.id)">
				<i class="fa fa-pencil"></i>
			</a>
		</bb-table-cell>
	</bb-table-row>
</bb-table-container>
<bb-table-pager [total]="mediaclip?.subtitles?.length" (pageNumber)="subtitlePageChanged($event)"></bb-table-pager>

<div class="header">
	<h3>
		{{ 'AUDIO_TRACKS' | translate }}
	</h3>
	<bb-info [contents]="'HELP.UPLOAD_AUDIO_TRACKS' | translate" [icon]="'help'"></bb-info>
</div>

<div class="header">
	<bb-upload (bbFileCreated)="audiotrackFileCreated($event)" [multi]="false" [onFilter]="filterAudiotrackUploads" [hideDropText]="true" [uploadText]="'UPLOAD_AUDIOTRACK' | translate"></bb-upload>
</div>


<bb-table-container>

	<bb-table-header>
		<bb-table-header-cell property="language">{{ 'LANGUAGE' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="status" class="icon" [ngClass]="{'status': rowsContainLiveClips}">&nbsp;</bb-table-header-cell>
		<bb-table-header-cell class="buttons"></bb-table-header-cell>
	</bb-table-header>

	<bb-table-row *ngIf="audiotrackRows?.length === 0">
		<bb-table-cell property="language" class="overflow"><span>{{ 'NO_AUDIO_TRACKS_YET' | translate }}</span></bb-table-cell>
		<bb-table-cell property="status">&nbsp;</bb-table-cell>
		<bb-table-cell property="status">&nbsp;</bb-table-cell>
	</bb-table-row>

	<bb-table-row *ngFor="let row of audiotrackRows; let i = index; trackBy: trackBy" [row]="row">
		<bb-table-cell property="language" class="overflow"><span>{{ row?.data?.languagename || row?.data?.name }}</span></bb-table-cell>
		<bb-table-cell property="status" [ngClass]="{'status': row?.data?.status}"><span [innerHTML]="row?.data | statusIcon"></span></bb-table-cell>
		<bb-table-cell class="buttons">

			<a [ngClass]="{'disabled': !row?.data?.uri || !defaultMediaAssetPath}" class="button" [href]="defaultMediaAssetPath + row?.data?.uri">
				<i class="fa fa-download"></i>
			</a>
			<a class="button" [class.disabled]="row?.id === 'new'" [class.active]="row?.quickEditing" (click)="row.quickEditing = ! row.quickEditing">
				<i class="fa fa-pencil"></i>
			</a>

		</bb-table-cell>
		<div quickedit>
			<audiotrack-quickedit [row]="row" [languages]="languages" *ngIf="row?.quickEditing && languages?.length" (canceled)="onItemRemoved(audiotrackRows, i)" (removed)="onItemRemoved(audiotrackRows, i)">
			</audiotrack-quickedit>
		</div>
	</bb-table-row>

</bb-table-container>

<bb-table-pager [total]="mediaclip?.audiotracks?.length" (pageNumber)="audiotracksPageChanged($event)"></bb-table-pager>

<!-- Transcript -->
<div [hasPublicationField]="'useTranscriptionService'">
	<div class="header">
		<h3>{{ 'TRANSCRIPT' | translate }}</h3>
		<bb-info [contents]="'HELP.UPLOAD_AUDIO_TRACKS' | translate" [icon]="'help'"></bb-info>
	</div>

	<div *ngIf="currentTranscript && currentTranscript.status !== 'error'">
		{{ "TRANSCRIPTION_RESULT" | translate:{ status: currentTranscript.status, isocode: currentTranscript.isocode } }}
	</div>
	<div *ngIf="currentTranscript && currentTranscript.status === 'error'" class="warning message">
		{{ "TRANSCRIPTION_ERROR" | translate }} 
		<span *ngIf="currentTranscript.errorMessage">: {{ currentTranscript.errorMessage | translate }}</span>
	</div>

	<div *ngIf="(currentTranscript && currentTranscript.status === 'error') || !currentTranscript">
		<bb-entity-selector 
			[(ngModel)]="transcriptionLanguage"
			name="transcription-language"
			[options]="transcriptionLanguageOptions"
			[disableClear]="true"
			placeholder="{{'SELECT_LANGUAGE' | translate}}"
		></bb-entity-selector>
		<br />
		<bb-button (click)="generateTranscript()" [disabled]="generatingTranscript || !transcriptionLanguage">
			<i *ngIf="generatingTranscript" class="fa fa-circle-o-notch fa-spin"></i>
			{{ (generatingTranscript ? 'GENERATE_TRANSCRIPT' : 'GET_TRANSCRIPT') | translate }}
		</bb-button>
	</div>
</div>
